import React, { useEffect } from 'react';
import {
  useLocation,
} from 'react-router-dom';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

import meta from '~/commons/config/meta';

import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';
import AccordionHeader from '~/commons/components/AccordionHeader.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Padding from '../layout/Padding.jsx';

const PageViewSlot = () => {
  const { pathname: key } = useLocation();
  const [res, req] = useHttpStatus({
    onSuccess: ({ data: { title } }) => {
      if (title) meta.set({ title });
    },
  });
  useEffect(() => {

    req({ url: `api/site/view-slots/home${key}` });
  }, [key]);

  return (
    <PageHttp res={res}>
      {(view) => (
        <>
          <div
            className={`
              jumbotron jumbotron-fluid
              position-relative vh-50 m-0
            `}
            style={{
              maxHeight: '250px',
            }}
          >
            {view.coverImg && (
              <div
                className="img-bg-cover"
                style={{
                  backgroundImage: `url(${view.coverImg})`,
                }}
              ></div>
            )}
            <div className="pos-abs-center bg-white px-5 py-2">
              <h1 className="m-0">
                <div className="small-sm smaller-xs">
                  {view.title}
                </div>
              </h1>
            </div>
          </div>
          <div className="my-4">
            <Padding>
              {view.content && (
                <Html className="readable ql-editor">
                  {view.content}
                </Html>
              )}
              {view?.list?.length > 0 && view.list.map((l, i) => (
                <div
                  className="row py-3 border-bottom align-items-center"
                  key={i}
                >
                  <div className="col">
                    {l.header && (
                      <h5>{l.header}</h5>
                    )}
                    {l.subheader && (
                      <div className="text-muted">{l.subheader}</div>
                    )}
                  </div>
                  {l.attachment && (
                    <div className="col-auto">
                      <a
                        href={l.attachment.url}
                        className="btn btn-primary rounded-pill py-2 px-3"
                        download={l.attachment.originalname}
                      >
                        下載詳情
                      </a>
                    </div>
                  )}
                </div>
              ))}
              {view?.collapsibles?.length > 0 && (
                <div className="readable">
                  <Accordion>
                    {view.collapsibles.map((c, i) => (
                      <Card key={c._id}>
                        <AccordionHeader eventKey={c._id}>
                          {i + 1}. {c.header}
                        </AccordionHeader>
                        <Accordion.Collapse eventKey={c._id}>
                          <Card.Body className="border-top">
                            <Html>{c.content}</Html>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    ))}
                  </Accordion>
                </div>
              )}
            </Padding>
          </div>
        </>
      )}
    </PageHttp>
  );
};

export default PageViewSlot;
